import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { calculateOffset } from '../../../store/map';
import useSrcScript from '../../../hooks/useSrcScript';
import googleSrc from '../../../scripts/googlePlaces';
import FakeMarker from './FakeMarker';
import { useSelector } from 'react-redux';
import { selectActivePage } from '../../../store/ui';
import { selectLandingType } from '../../../store/plans';

const MapContainer = styled.div`
	min-height: -webkit-fill-available;
	position: relative;
	overflow-x: hidden;
	overflow-y: hidden;
	position: absolute;
	${({ customStyles }) => customStyles};
	&::-webkit-scrollbar {
		display: none;
	}

	@media screen and (min-width: 744px) {
		overflow-y: auto;
	}
`;

const Map = ({
	lat,
	lng,
	customHeight = '100%',
	customWidth = '100%',
	customStyles = '',
	zoom = 3,
}) => {
	const googleMapRef = useRef();
	const [googleMap, setGoogleMap] = useState(null);
	const { newLat, newLng } = calculateOffset(lat, lng);
	const activePage = useSelector(selectActivePage);
  const landingType = useSelector(selectLandingType);
	const status = useSrcScript(googleSrc, landingType === 'extendfull_up' || landingType === 'cutfull_up');
	const isSpecialFlow = ['extendfull_up', 'cutfull_up'].includes(landingType);

	useEffect(() => {
		if (status === 'ready') {
			let mapObj = new window.google.maps.Map(googleMapRef.current, {
				zoom: zoom,
				center: { lat: newLat, lng: newLng },
				disableDefaultUI: true,
				clickableIcons: false,
				fullscreenControl: false,
				streetViewControl: false,
				mapTypeControl: false,
				mapTypeId: 'roadmap',
				gestureHandling: 'none'
			});
			setGoogleMap(mapObj);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [status]);

	return (
		<>
			<MapContainer
				customStyles={customStyles}
				style={{
					width: `${customWidth}` || '100%',
					height: `${
						customHeight || window.innerHeight - 0.001 * window.innerHeight
					}`,
				}}
			>
				<div
					ref={googleMapRef}
					id="google-map"
					style={{
						width: `${customWidth}` || '100%',
						height: `${
							customHeight || window.innerHeight - 0.001 * window.innerHeight
						}`,
					}}
				/>
			</MapContainer>
			{isSpecialFlow &&
				(activePage === 'approximate-location' || activePage === 'checkout') &&
				googleMap && <FakeMarker googleMap={googleMap} lat={lat} lng={lng} />}
		</>
	);
};

export default Map;
